// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const minccino: PokeData = {
  "id": 572,
  "name": "minccino",
  "height": 4,
  "weight": 58,
  "base_experience": 60,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "slam",
    "growl",
    "sing",
    "swift",
    "charm",
    "encore",
    "helping-hand",
    "hyper-voice",
    "tickle",
    "wake-up-slap",
    "last-resort",
    "captivate",
    "after-you",
    "echoed-voice",
    "tail-slap",
    "baby-doll-eyes"
  ],
  "moves": [
    "growl",
    "hyper-voice",
    "purification",
    "tri-attack",
    "leer",
    "scratch",
    "tackle",
    "refresh",
    "splash",
    "headbutt",
    "quick-attack",
    "scary-face",
    "protect"
  ],
  "evolution_chain": {
    "id": 292,
    "item": null,
    "species": [
      {
        "name": "minccino",
        "order": 573,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cinccino",
        "order": 574,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 572,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "shiny-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 47.5,
    "speed": 75,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
